<script>
import BasePopup from '@/components/BasePopup.vue';
import EllipsisMenu from '@/components/EllipsisMenu.vue';

export default {
  name: 'GuideItem',
  components: { EllipsisMenu, BasePopup },
  props: {
    guide: Object,
  },
  data() {
    return {
      isVideoOpen: false,
      isMenuVisible: false,
    };
  },
  computed: {
    isVideoOpened() {
      return this.$route.params.video === this.guide.id;
    },

    ellipsisMenuItems() {
      const items = [];
      items.push({
        text: 'Копировать ссылку',
        icon: 'share',
        handler: async () => {
          try {
            await navigator.clipboard.writeText(`${document.location.origin}${this.$route.fullPath}/${this.guide.id}`);
            this.$push({ text: `Ссылка на гайд "${this.guide.name}" скопирована` });
          } catch (e) {
            this.$push({ text: 'Произошла ошибка при копировании ссылки' });
          }
        },
      });

      return items;
    },
  },
  methods: {
    toggleVideoPlayer(url) {
      if (url) {
        this.$router.push({ params: { video: url } });
      } else {
        this.$router.push({ name: 'guides' });
      }
    },
  },
};
</script>

<template lang="pug">
.b-guide-tile(@mouseenter="isMenuVisible = true" @mouseleave="isMenuVisible = false")
  button._video(@click="toggleVideoPlayer(guide.id)")
    img._video-preview(v-if="guide.preview" :src="guide.preview.url")
    ._video-button
      Icon(pointer name="play-button")
  ._header {{ guide.name }}
  ._descriprion
    ._author {{ guide.author }}
    ._title {{ guide.authorDesc }}
    slot
  BasePopup(v-if="isVideoOpened" type="video" :src="guide.video.url" @close="toggleVideoPlayer")
  EllipsisMenu._menu(v-if="isMenuVisible" :items="ellipsisMenuItems")
</template>

<style scoped lang="scss">
.guide-tile {
  width: 100%;
  height: 300px;
  display: grid;
  box-sizing: border-box;
  grid-template-columns: 120px 1fr;
  grid-template-rows: repeat(2, min-content);
  column-gap: 27px;
  background: var(--color-white);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  align-content: space-between;
  position: relative;

  &__menu {
    position: absolute;
    bottom: 30px;
    right: 25px;
  }

  &__video {
    grid-column: 1;
    grid-row: 1 / 2 span;
    position: relative;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background-color: transparent;

    &:before {
      display: block;
      content: '';
      height: 100%;
      width: 100%;
      border-radius: 8px;
      position: absolute;
      z-index: 2;
      background: linear-gradient(360deg, rgba(30, 49, 71, 0.8) 0%, rgba(255, 255, 255, 0) 100%);
    }
  }

  &__video-preview {
    position: absolute;
    z-index: 1;
    object-fit: cover;
    height: 100%;
    width: 100%;
    border-radius: 8px;
  }

  &__video-button {
    cursor: pointer;
    border-radius: 50%;
    z-index: 4;
  }

  &__header {
    display: flex;
    flex-wrap: wrap;
    box-sizing: border-box;
    padding: 25px 25px 0 0;
    font-weight: 700;
    font-size: 16px;
    line-height: 21px;
  }

  &__descriprion {
    display: flex;
    flex-direction: column;
    gap: 4px;
    grid-row: 2;
    grid-column: 2;
    box-sizing: border-box;
    padding: 0 25px 25px 0;
  }

  &__author {
    font-size: 16px;
    font-weight: 600;
  }

  &__title {
    line-height: 19.6px;
    font-weight: 400;
    font-size: 14px;
    color:rgba(120, 140, 161, 1);
  }

  &__admin {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
}

@media (min-width: 768px) and (max-width: 1199px) {
  .guide-tile {
    width: 100%;
    height: 264px;
    grid-template-columns: 90px 1fr;
    column-gap: 24px;

    &__header {
      font-size: 14px;
      padding: 25px 19px 0 0;
    }

    &__descriprion {
      padding: 0 19px 25px 0;
    }

    &__author {
      font-size: 14px;
      font-weight: 600;
    }

    &__title {
      font-weight: 400;
      font-size: 12px;
    }
  }
}

@media (min-width: 320px) and (max-width: 767px) {
  .guide-tile {
    width: 100%;
    height: 264px;
    grid-template-columns: 90px 1fr;
    column-gap: 24px;

    &__header {
      font-size: 14px;
      padding: 25px 19px 0 0;
    }

    &__descriprion {
      padding: 0 19px 25px 0;
    }

    &__author {
      font-size: 14px;
      font-weight: 600;
    }

    &__title {
      font-weight: 400;
      font-size: 12px;
    }
  }
}
</style>
